// Surface tokens for panels/cards. The former frosted-glass look (translucent fill +
// backdrop blur) was removed app-wide in favour of solid HEX surfaces (gray via explicit
// HEX, never low-opacity white/black). Kept as named tokens so every call site stays a
// one-word swap and future restyles happen in one place.
export const GLASS_FILL = 'bg-[#1A1A1A] shadow-[0_6px_24px_rgba(0,0,0,0.25)]';

export const GLASS_BORDER = 'border border-[#2A2A2A]';
